import React, { useState, useEffect } from "react";
import { equifaxDataError } from "./data";

const CrifScoreReportModal2 = ({
  isOpen,
  onClose,
  Equifaxv2Report,
  Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
}) => {
  useEffect(() => {
 // console.log("crif v2",Equifaxv2Report);
  }, [Equifaxv2Report], [Equifaxv2Error]);


  const [isPrinting, setIsPrinting] = useState(false);

  if (!isOpen) return null; // Do not render anything if not open

  const printDiv = () => {
    setIsPrinting(true);

    // Create a temporary window for printing 
    const printWindow = window.open("", "", "height=700,width=1000");
    const printContents = document.getElementById("invoicedata").innerHTML;

    // Write the content to the new window
    printWindow.document.write("<html><head><title>Crif Score Report</title>");
    printWindow.document.write(
      '<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">'
    );
    printWindow.document.write("</head><body >");
    printWindow.document.write(printContents);
    printWindow.document.write("</body></html>");

    printWindow.document.close();
    printWindow.focus();

    setTimeout(() => {
      printWindow.print();

      setIsPrinting(false);
    }, 100);
  };



  const modalData = Equifaxv2Report && Equifaxv2Report;
  const modalDataError = Equifaxv2Error && Equifaxv2Error;
  return (
    <div className="fixed inset-0 flex  flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-4">
      <div
        className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]"
        id="invoicedata"
      >
        <div className="a4-page">
         
     


<div className="grid grid-cols-12 items-center gap-2 border-b pb-1 mt-1">

  {/* Logo - Start */}
  <div className="col-span-12 sm:col-span-3 flex justify-center sm:justify-start">
    <img
      // src="/assets/images/CrifScoreLogo.webp"
      src="https://imgs.search.brave.com/F-FGsx3dw-ufK7fWVZmHd93EObunBV0adl6hfaiK9Zs/rs:fit:0:180:1:0/g:ce/aHR0cHM6Ly9kMjh3/dThvNml0djg5dC5j/bG91ZGZyb250Lm5l/dC9pbWFnZXMvQ1JJ/RmhpZ2htYXJrcG5n/LTE1NzQ4NDY5NTk0/NjgucG5n"
      className="w-12 sm:w-28 md:w-28"
      alt="Company Logo"
    />
  </div>

  {/* Center Content */}
  <div className="col-span-12 sm:col-span-6 text-center">
    <h4 className="text-base sm:text-md md:text-md font-semibold">
     Consumer Credit Report
    </h4>

    <p className="text-xs sm:text-xs mt-1">
      <span className="font-semibold">For :</span>{" "}
      <span className="font-bold"> 
        {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["NAME-VARIATIONS"]?.["VARIATION"]?.[2]?.["VALUE"] ||
          (modalDataError?.data?.first_name && modalDataError?.data?.last_name
            ? `${modalDataError?.data?.first_name} ${modalDataError?.data?.last_name}`
            : modalDataError?.data?.first_name ||
              modalDataError?.first_name ||
              modalDataError?.error?.first_name ||
              "N/A")}
      </span>
    </p>
  </div>

  {/* End Section */}
  <div className="col-span-12 sm:col-span-3 text-center sm:text-right text-xs sm:text-[10px]">
    <p>
      <span className="font-bold text-blue-600">CHM Ref:</span>{" "}
      <span className="font-semibold">{modalData?.credit_report?.["HEADER"]?.["REPORT-ID"] || "N/A"}</span>
    </p>
    <p>
      <span className="font-bold text-blue-600">Date of Request:</span>{" "}
      <span className="font-semibold">{modalData?.credit_report?.["HEADER"]?.["DATE-OF-REQUEST"] || "N/A"}</span>
    </p>
    <p>
      <span className="font-bold text-blue-600">Date of Issue:</span>{" "}
      <span className="font-semibold">{modalData?.credit_report?.["HEADER"]?.["DATE-OF-ISSUE"] || "N/A"}</span>
    </p>
  </div>

</div>


         

          {displayMessageBlock && (() => {
            const message =
              Equifaxv2Error?.error?.credit_report_message?.message ||
              Equifaxv2Error?.message ||
              Equifaxv2Report?.message ||
              reportMessage ||
              "";

            const code =
              Equifaxv2Error?.error?.credit_report_message?.message_code ||
              Equifaxv2Error?.message_code ||
              Equifaxv2Report?.message_code ||
              reportCode ||
              "";

          const isSuccess = /sucess|success/i.test(message);

            // 🛑 Don't show anything if it's success
            if (isSuccess) return null;

            const formatText = (text) =>
              text?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

            return (
              <>{(message?.length > 0 || code?.length > 0) && (
                <div className="flex flex-col items-center justify-center my-5">
                  <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                    <p className="text-center text-black font-bold">
                      Error: <span className="font-normal">{formatText(message)}</span>
                    </p>
                    <p className="text-center text-black font-bold mt-1">
                      Code: <span className="font-normal">{formatText(code)}</span>
                    </p>
                  </div>
                </div>
              )}
              </>
            );
          })()}


          <div className="flex justify-center">
            <p className="font-bold text-black text-sm">Personal Details</p>
          </div>

          <div className="border border-blue-500 p-2 rounded-md">
            <div className="grid grid-cols-2 md:grid-cols-2  gap-1 text-xs">
              {/* Consumer Name */}
              <div>
                <p>
                  <i className="font-semibold">Consumer Name : </i>
                  <span>
                    {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["NAME-VARIATIONS"]?.["VARIATION"]?.[2]?.["VALUE"] ||
                      (modalDataError?.data?.first_name && modalDataError?.data?.last_name
                        ? `${modalDataError?.data?.first_name} ${modalDataError?.data?.last_name}`
                        : modalDataError?.data?.first_name ||
                        modalDataError?.first_name ||
                        modalDataError?.error?.first_name ||
                        "N/A")}
                  </span>

                </p>
              </div>

              <div>
                <p className="text-xs">
                  <i className="font-semibold">D.o.b</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["DATE-OF-BIRTH-VARIATIONS"]?.["VARIATION"]?.[0]?.["VALUE"] || "N/A"}
                  </span>
                </p>
              </div>

              <div>
                <p className="text-xs">
                  <i className="font-semibold">Age</i>
                  <span>
                    {" "}
                    :{" "}
                    {
                      modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["DATE-OF-BIRTH-VARIATIONS"]?.["VARIATION"]?.[0]?.["VALUE"]
                        ? new Date().getFullYear() - parseInt(
                          modalData?.credit_report["PERSONAL-INFO-VARIATION"]["DATE-OF-BIRTH-VARIATIONS"]["VARIATION"][0]["VALUE"].split('-')[2]
                        )
                        : "N/A"
                    }

                  </span>
                </p>
              </div>

              <div>
                <p className="text-xs">
                  <i className="font-semibold">Gender</i>
                  <span>
                    {" "}
                    :{" "}
                    {modalData?.CCRResponse?.CIRReportDataLst?.[0]
                      ?.CIRReportData?.IDAndContactInfo?.PersonalInfo?.Gender ||
                      modalDataError?.data?.gender ||
                      modalDataError?.gender ||
                      modalDataError?.error?.gender ||
                      "N/A"}
                  </span>
                </p>
              </div>

              <div>
                <p className="text-xs">
                  <i className="font-semibold">Mob</i>
                  <span>
                    {" "}
                    :{" "}
       
                    {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["PHONE-NUMBER-VARIATIONS"]?.["VARIATION"]?.[0]?.["VALUE"] ||
                      modalDataError?.data?.mobile ||
                      modalDataError?.error?.mobile ||
                      "N/A"}
                  </span>
                </p>
              </div>

              <div>
                {/* PAN */}
                <p className="text-xs">
                  <i className="font-semibold">PAN</i>:{" "}
                  {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["PAN-VARIATIONS"]?.["VARIATION"]?.["VALUE"]
                    || modalDataError?.data?.pan || "N/A"
                  }
                </p>

                {/* UID (may be an array) */}
                <p className="text-xs">
                  <i className="font-semibold">UID</i>:{" "}
                  {Array.isArray(modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["UID-VARIATIONS"]?.["VARIATION"])
                    ? modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["UID-VARIATIONS"]?.["VARIATION"]
                      .map((item) => item?.["VALUE"])
                      .join(", ")
                    : modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["UID-VARIATIONS"]?.["VARIATION"]?.["VALUE"] || "N/A"}
                </p>
                <p className="text-xs">
                  <i className="font-semibold">Ration ID</i>:{" "}
                  {Array.isArray(
                    modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["RATION-CARD-VARIATIONS"]?.["VARIATION"]
                  )
                    ? modalData?.credit_report["PERSONAL-INFO-VARIATION"]?.["RATION-CARD-VARIATIONS"]?.["VARIATION"]
                      .map((item) => item?.["VALUE"])
                      .join(", ")
                    : modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["RATION-CARD-VARIATIONS"]?.["VARIATION"]?.["VALUE"] || "N/A"}
                </p>


                {/* Other ID */}
                <p className="text-xs">
                  <i className="font-semibold">Other ID</i>:{" "}
                  {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["OTHER-ID-VARIATIONS"]?.["VARIATION"]?.["VALUE"] || "N/A"}
                </p>

              </div>
            </div>
          </div>

          <hr className="my-2" />
          <div className="  bg-blue-200 md:text-black text-black p-1 border rounded rounded-tl-xl rounded-tr-xl text-sm font-semibold">
            Address
          </div>
          <table className="min-w-full table-auto border border-black text-left text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-black px-1 py-0">Sn</th>
                <th className="border border-black px-0 py-0">Address</th>
              </tr>
            </thead>
            <tbody className="address-info text-xs">
              {Array.isArray(
                modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["ADDRESS-VARIATIONS"]?.["VARIATION"]
              ) && modalData?.credit_report["PERSONAL-INFO-VARIATION"]?.["ADDRESS-VARIATIONS"]?.["VARIATION"].length > 0 ? (
                modalData?.credit_report["PERSONAL-INFO-VARIATION"]?.["ADDRESS-VARIATIONS"]?.["VARIATION"]?.map(
                  (address, index) => (
                    <tr key={index}>
                      <td className="border border-black px-1 py-0 font-bold">
                        Address {index + 1}
                      </td>
                      <td className="border border-black px-0 py-0">
                        {address.VALUE}
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td
                    colSpan="2"
                    className="border border-black px-2 py-1 text-center"
                  >
                    No address information available.
                  </td>
                </tr>
              )}
            </tbody>

          </table>

          {/* Credit Score Section */}
          <div className=" bg-blue-300 md:text-black p-1 text-black mt-1 rounded-tl-md rounded-tr-md text-sm font-semibold">
            Crif Credit Score
          </div>
          <table className="min-w-full table-auto border border-black text-left text-sm">
            <thead className="bg-gray-200">
              <tr className="text-left text-xs">
                <th className="border border-black px-1 py-0">Score Name</th>
                <th className="border border-black px-1 py-0">Scoring Elements</th>
                <th className="border border-black px-1 py-0">Score</th>
              </tr>
            </thead>
            <tbody className="scoreDetailsInfo text-xs">
              {(() => {
                const scoresData = modalData?.credit_report?.SCORES?.SCORE;

                if (!scoresData) {
                  return (
                    <tr>
                      <td colSpan="3" className="border border-black px-1 py-0 text-center">
                        No score details available.
                      </td>
                    </tr>
                  );
                }

                // Ensure we always work with an array
                const scoresArray = Array.isArray(scoresData) ? scoresData : [scoresData];

                return scoresArray.map((score, idx) => (
                  <tr key={idx}>
                    <td className="border border-black px-1 py-0">
                      {score["SCORE-TYPE"] || "N/A"}
                    </td>

                    <td className="border border-black px-1 py-0">
                      <ul>
                        {score["SCORE-FACTORS"]
                          ? score["SCORE-FACTORS"]
                            .split("|")
                            .filter(Boolean)
                            .map((factor, i) => (
                              <li key={i}>{factor}</li>
                            ))
                          : <li>No scoring elements available.</li>}
                      </ul>
                    </td>
                    <td className="border border-black px-1">
                      <div className="flex flex-col items-center justify-center bg-green-300 rounded-lg border-green-700 border p-1 w-16 h-12">
                        <span className="text-2xl font-bold text-blue-900">
                          {score["SCORE-VALUE"] || "N/A"}
                        </span>
                        <span className="text-xs font-semibold text-blue-900">Score</span>
                      </div>
                    </td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>



<div className="bg-blue-100 text-black p-2 mt-2 rounded-md text-sm font-semibold">
  Account Imformation:
</div>

{Array.isArray(modalData?.credit_report?.RESPONSES?.RESPONSE) &&
modalData.credit_report.RESPONSES.RESPONSE.length > 0 ? (
  modalData.credit_report.RESPONSES.RESPONSE.map((item, index) => {
    const account = item["LOAN-DETAILS"];

    // Build yearly payment history
    const buildPaymentHistory = (combinedHistory) => {
      if (!combinedHistory) return { months: [], history: {} };

      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const yearsData = {};

      const entries = combinedHistory.split("|").filter(Boolean);
      
      entries.forEach((entry) => {
        const [monthYear, status] = entry.split(",");
        if (!monthYear || !status) return;

        const [month, year] = monthYear.split(":");
        const monthIndex = months.findIndex(m => m.toLowerCase() === month.toLowerCase());
        
        if (monthIndex === -1 || !year) return;

        if (!yearsData[year]) {
          yearsData[year] = Array(12).fill("-");
        }

        yearsData[year][monthIndex] = status.trim();
      });

      return { months, history: yearsData };
    };

    const { months, history } = buildPaymentHistory(account?.["COMBINED-PAYMENT-HISTORY"]);

    // Color coding function based on the image
    const getStatusColor = (value) => {
      if (value === "-") return "bg-white text-gray-400";
      if (value.includes("XXX")) return "bg-gray-200 text-gray-600";
      if (value.includes("000") || value.includes("STD")) return "bg-white text-gray-700";
      return "bg-white text-gray-700";
    };

    return (
      <div
        key={index}
        className="mb-2 border border-gray-300 rounded bg-white shadow-sm"
      >
        {/* Header Section - Blue Background */}
        <div className="bg-blue-100 px-2 rounded-t grid grid-cols-5 md:grid-cols-5 gap-1 md:text-[10px] text-[9px]">
          <div>
            <span className="font-bold text-blue-600"><span className="bg-black text-white px-1 py-0"> {index + 1}</span> Account Type:</span>
            <div className="font-semibold text-red-600">{account?.["ACCT-TYPE"] || "Gold Loan"}</div>
          </div>
          <div>
            <span className="font-bold text-blue-600">Credit Grantor:</span>
            <div className="font-semibold text-red-600">{account?.["CREDIT-GUARANTOR"] || "N/A"}</div>
          </div>
          <div>
            <span className="font-bold text-blue-600">Account #:</span>
            <div className="font-semibold text-red-600">{account?.["ACCT-NUMBER"] || "N/A"}</div>
          </div>
          <div>
            <span className="font-bold text-blue-600">Lender Type:</span>
            <div className="font-semibold text-red-600">{account?.["LENDER-TYPE"] || ""}</div>
          </div>
          <div>
            <span className="font-bold text-blue-600">As on:</span>
            <div className="font-semibold text-red-600">{account?.["DATE-REPORTED"] || "N/A"}</div>
          </div>
        </div>

        {/* Main Details Grid */}
        <div className="grid grid-cols-3 md:grid-cols-3 gap-x-3 gap-y-0 p-2 md:text-[10px] text-[9px] bg-blue-100">
          {/* Left Column */}
          <div className="space-y-1">
            <p className="font-semibold"><span className="font-bold text-blue-800">Ownership:</span> {account?.["OWNERSHIP-IND"] || "Individual"}</p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Credit Limit:</span></p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Cash Limit:</span></p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Inst/Amt/Freq:</span></p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Write off Date:</span></p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Status:</span> {account?.["ACCOUNT-STATUS"] || "Closed"}</p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Settlement Amt:</span>{account?.["SETTLEMENT-AMT"] || "0"}</p>
          </div>

          {/* Middle Column */}
          <div className="space-y-1">
            <p className="font-semibold"><span className="font-bold text-blue-800">Disbursed Date:</span> {account?.["DISBURSED-DT"] || "N/A"}</p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Last Payment Date:</span> {account?.["LAST-PAYMENT-DATE"] || "N/A"}</p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Closed Date:</span> {account?.["CLOSED-DT"] || "N/A"}</p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Tenure (months):</span> {account?.["REPAYMENT-TENURE"] || "N/A"}</p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Account In Dispute:</span></p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Income/Frq:</span></p>
            <p className="font-semibold"><span className="font-bold text-blue-800">Interest Rate:</span> {account?.["INTEREST-RATE"] || "N/A"}%</p>
          </div>

          {/* Right Column */}
          <div className="space-y-1">
             <p className="font-semibold"><span className="font-bold text-blue-800">Disbd Amt/High Credit:</span> {account?.["DISBURSED-AMT"] || "0"}</p>
             <p className="font-semibold"><span className="font-bold text-blue-800">Current Balance:</span> {account?.["CURRENT-BAL"] || "0"}</p>
             <p className="font-semibold"><span className="font-bold text-blue-800">Last Paid Amt:</span> {account?.["ACTUAL-PAYMENT"] || "0"}</p>
             <p className="font-semibold"><span className="font-bold text-blue-800">Overdue Amt:</span> {account?.["OVERDUE-AMT"] || "0"}</p>
             <p className="font-semibold"><span className="font-bold text-blue-800">Principal Writeoff Amt:</span></p>
             <p className="font-semibold"><span className="font-bold text-blue-800">Total Writeoff Amt:</span> {account?.["WRITE-OFF-AMT"] || "0"}</p>
          </div>
        </div>

        {/* Payment History Table */}
        <div className="">
          <div className="text-black px-2 py-2 text-xs font-semibold">
            Payment History/Asset Classification:
          </div>
          
          <div className="overflow-x-auto border border-gray-300">
            <table className="w-full text-center text-xs border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-1 font-semibold"></th>
                  {months.map((m, idx) => (
                    <th key={idx} className="border border-gray-300 p-1 font-bold text-blue-700">
                      {m}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {Object.keys(history).length > 0 ? (
                  Object.keys(history)
                    .sort((a, b) => b - a)
                    .map((year, yIdx) => (
                      <tr key={yIdx} className="border-b">
                        <td className="border border-gray-300 p-1 font-bold bg-gray-50">{year}</td>

                        {history[year].map((value, mIdx) => (
                          <td key={mIdx} className={`border border-gray-300 p-1 text-[9px] font-semibold ${getStatusColor(value)}`}>
                            {value}
                          </td>
                        ))}
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={13} className="p-3 text-center text-gray-500">
                      No payment history available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  })
) : (
  <div className="border p-4 text-center text-xs bg-white">
    No account details available.
  </div>
)}


   <div className="w-full overflow-x-auto">
      <table className="w-full border border-gray-300 text-[10px] font-semibold">
        <thead className="bg-blue-200">
          <tr>
            <th className="border px-1 py-0.5 text-left">Section</th>
            <th className="border px-1 py-0.5 text-left">Code</th>
            <th className="border px-1 py-0.5 text-left">Description</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className="border px-1 py-0.5">Account Summary</td>
            <td className="border px-1 py-0.5">Number of Delinquent Accounts</td>
            <td className="border px-1 py-0.5">
              Number of accounts defaulted within last 6 months
            </td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Account Information - Credit Grantor</td>
            <td className="border px-1 py-0.5">XXXX</td>
            <td className="border px-1 py-0.5">
              Credit grantor name undisclosed
            </td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Account Information - Account #</td>
            <td className="border px-1 py-0.5">XXXX</td>
            <td className="border px-1 py-0.5">
              Account number undisclosed
            </td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Payment History / Asset Classification</td>
            <td className="border px-1 py-0.5">XXX</td>
            <td className="border px-1 py-0.5">
              Data not reported by institution
            </td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Payment History / Asset Classification</td>
            <td className="border px-1 py-0.5">STD</td>
            <td className="border px-1 py-0.5">Standard Asset</td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Payment History / Asset Classification</td>
            <td className="border px-1 py-0.5">SUB</td>
            <td className="border px-1 py-0.5">Sub-Standard Asset</td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Payment History / Asset Classification</td>
            <td className="border px-1 py-0.5">DBT</td>
            <td className="border px-1 py-0.5">Doubtful Asset</td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Payment History / Asset Classification</td>
            <td className="border px-1 py-0.5">LOS</td>
            <td className="border px-1 py-0.5">Loss Asset</td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Payment History / Asset Classification</td>
            <td className="border px-1 py-0.5">SMA</td>
            <td className="border px-1 py-0.5">Special Mention Account</td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">CRIF Highmark Score</td>
            <td className="border px-1 py-0.5">PERFORM - Consumer</td>
            <td className="border px-1 py-0.5">
              Score based on credit history & debt
            </td>
          </tr>

          <tr>
            <td className="border px-1 py-0.5">Account Information - Account #</td>
            <td className="border px-1 py-0.5">CI-Ceased</td>
            <td className="border px-1 py-0.5">
              Institution ceased or membership terminated
            </td>
          </tr>
        </tbody>
      </table>
    </div>




          {/* Recent Activity Section */}
          <div className="  bg-blue-300 md:text-black text-black p-1 rounded-tr-md rounded-tl-md text-sm font-semibold">
            Recent Activity (Last 90 Days)
          </div>
          <table className="min-w-full table-auto border border-black text-left text-xs">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-black px-4 py-2">Member Name</th>
                <th className="border border-black px-4 py-2">Inquiry Date</th>
                <th className="border border-black px-4 py-2">Purpose</th>
                <th className="border border-black px-4 py-2">Ownership Type</th>
                <th className="border border-black px-4 py-2">Amount</th>
                <th className="border border-black px-4 py-2">Remark</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY) ? (
                modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY.map((history, idx) => (
                  <tr key={idx} className="border border-black">
                    <td className="border border-black px-4 py-2">{history["MEMBER-NAME"]}</td>
                    <td className="border border-black px-4 py-2">{history["INQUIRY-DATE"]}</td>
                    <td className="border border-black px-4 py-2">{history["PURPOSE"]}</td>
                    <td className="border border-black px-4 py-2">{history["OWNERSHIP-TYPE"]}</td>
                    <td className="border border-black px-4 py-2">{history["AMOUNT"]}</td>
                    <td className="border border-black px-4 py-2">{history["REMARK"] || "N/A"}</td>
                  </tr>
                ))
              ) : modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY ? (
                <tr className="border border-black">
                  <td className="border border-black px-4 py-2">
                    {modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY["MEMBER-NAME"]}
                  </td>
                  <td className="border border-black px-4 py-2">
                    {modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY["INQUIRY-DATE"]}
                  </td>
                  <td className="border border-black px-4 py-2">
                    {modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY["PURPOSE"]}
                  </td>
                  <td className="border border-black px-4 py-2">
                    {modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY["OWNERSHIP-TYPE"]}
                  </td>
                  <td className="border border-black px-4 py-2">
                    {modalData?.credit_report["INQUIRY-HISTORY"].HISTORY["AMOUNT"]}
                  </td>
                  <td className="border border-black px-4 py-2">
                    {modalData?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY["REMARK"] || "N/A"}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={6} className="border border-black text-center">
                    No inquiry history available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        </div>

 
 {/* Summary Header */}
<div className="bg-blue-300 text-black p-2 mt-1 text-sm font-semibold">
  Summary
</div>

{/* Table 1 – Accounts Overview */}
<table className="min-w-full table-auto border border-gray-300 text-left text-xs mb-2">
  <thead className="bg-gray-200">
    <tr>
      <th className="border px-2 py-1">Number of Accounts</th>
      <th className="border px-2 py-1">Total Balance Amount</th>
      <th className="border px-2 py-1">New Accounts (Last 6 Months)</th>
      <th className="border px-2 py-1">New Delinquent Accounts</th>
    </tr>
  </thead>
  <tbody className="bg-white hover:bg-gray-100">
    <tr>
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-NUMBER-OF-ACCOUNTS"]}
      </td>
      <td className="border px-2 py-1 text-green-600 font-bold">
        ₹{modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-CURRENT-BALANCE"]}
      </td>
      <td className="border px-2 py-1 text-yellow-600 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"]}
      </td>
      <td className="border px-2 py-1 text-red-600 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"]}
      </td>
    </tr>
  </tbody>
</table>

{/* Table 2 – Open & Overdue Accounts */}
<table className="min-w-full table-auto border border-gray-300 text-left text-xs mb-2">
  <thead className="bg-gray-200">
    <tr>
      <th className="border px-2 py-1">Open Accounts</th>
      <th className="border px-2 py-1">Overdue Accounts</th>
      <th className="border px-2 py-1">Length of Credit History (Years)</th>
      <th className="border px-2 py-1">Length of Credit History (Months)</th>
      <th className="border px-2 py-1">Average Account Age</th>
    </tr>
  </thead>
  <tbody className="bg-white hover:bg-gray-100">
    <tr>
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}
      </td>
      <td className="border px-2 py-1 text-red-600 font-bold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}
      </td>
      <td className="border px-2 py-1 text-gray-700 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-YEAR"]}
      </td>
      <td className="border px-2 py-1 text-gray-700 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-MONTH"]}
      </td>
      <td className="border px-2 py-1 text-green-700 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-YEAR"]}y 
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-MONTH"]}m
      </td>
    </tr>
  </tbody>
</table>

{/* Table 3 – Credit & Sanction Summary */}
<table className="min-w-full table-auto border border-gray-300 text-left text-xs mb-2">
  <thead className="bg-gray-200">
    <tr>
      <th className="border px-2 py-1">Secured Accounts</th>
      <th className="border px-2 py-1">Unsecured Accounts</th>
      <th className="border px-2 py-1">Sanctioned Amount</th>
      <th className="border px-2 py-1">Disbursed Amount</th>
    </tr>
  </thead>
  <tbody className="bg-white hover:bg-gray-100">
    <tr>
      <td className="border px-2 py-1 text-blue-600 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SECURED-NUMBER-OF-ACCOUNTS"]}
      </td>
      <td className="border px-2 py-1 text-yellow-600 font-semibold">
        {modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS"]}
      </td>
      <td className="border px-2 py-1 text-green-600 font-bold">
        ₹{modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SANCTIONED-AMOUNT"]}
      </td>
      <td className="border px-2 py-1 text-purple-600 font-bold">
        ₹{modalData?.credit_report?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-DISBURSED-AMOUNT"]}
      </td>
    </tr>
  </tbody>
</table>



       <div className='mt-4'>
  <h3 className="text-green-800 text-center font-bold">END of Report  {" "}
                  :{" "}
            {modalData?.credit_report?.["PERSONAL-INFO-VARIATION"]?.["NAME-VARIATIONS"]?.["VARIATION"]?.[2]?.["VALUE"] ||
                      (modalDataError?.data?.first_name && modalDataError?.data?.last_name
                        ? `${modalDataError?.data?.first_name} ${modalDataError?.data?.last_name}`
                        : modalDataError?.data?.first_name ||
                        modalDataError?.first_name ||
                        modalDataError?.error?.first_name ||
                        "N/A")}
          </h3>
        </div>


      </div>
      <div className="flex justify-center mt-4">
        <button
          className="bg-green-500 text-white p-1 rounded hover:bg-green-700"
          onClick={printDiv}
          disabled={isPrinting}
        >
          Print
        </button>
        <button
          className="bg-red-500 text-white p-1 rounded hover:bg-red-700"
          onClick={onClose} // This should close the modal
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default CrifScoreReportModal2;
